<script setup lang="ts">
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  WEB_APP_URL
} from '~/constants/website'
import { Motion } from 'motion-v'

withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    description?: string
  }>(),
  {
    title: 'Mulai Kirim Paketmu Sekarang!',
    subtitle: 'Satu Solusi untuk Semua #PastiAman',
    description:
      'Jadikan pengalaman pengiriman paket lebih mudah dengan aplikasi KiriminAja.'
  }
)
const mobileView = useState('mobileView', () => false)

const route = useRoute()
if (route.query.platform) {
  mobileView.value = true
}

const { $utm } = useNuxtApp()
</script>

<template>
  <section
    v-if="!mobileView"
    class="bg-secondary-container dark:bg-surface-container-high text-on-secondary-container"
  >
    <UiContainer
      class="grid xl:grid-cols-2 items-center relative overflow-hidden"
    >
      <div class="flex flex-col gap-3 lg:gap-7 py-10 lg:py-20">
        <Motion
          class="flex flex-col gap-2"
          :initial="{ opacity: 0, translateY: 40 }"
          :while-in-view="{ opacity: 1, translateY: 0 }"
          :in-view-options="{ once: true }"
        >
          <p
            class="text-primary leading-8 text-lg lg:text-xl font-semibold w-11/12"
            v-text="subtitle"
          ></p>
          <h2
            class="w-full text-2xl lg:text-4xl font-bold font-display leading-[120%] tracking-[-0.034rem]"
            v-text="title"
          ></h2>
          <p
            class="opacity-80 lg:text-lg w-full lg:w-3/4"
            v-text="description"
          ></p>
        </Motion>
        <slot name="action">
          <div class="flex items-center gap-4">
            <Motion
              class="flex flex-col gap-4"
              :initial="{ opacity: 0, translateY: 40 }"
              :while-in-view="{ opacity: 1, translateY: 0 }"
              :in-view-options="{ once: true }"
            >
              <NuxtLink
                :to="$utm.utmUrl(GOOGLE_PLAY_URL, undefined, true)"
                rel="noopener noreferrer"
              >
                <NuxtImg
                  alt="google-play"
                  src="/images/home-v4/playstore.webp"
                  width="177px"
                  height="52px"
                  class="max-w-full lg:h-13 rounded-xl border border-transparent dark:border-outline-variant"
                />
              </NuxtLink>
              <NuxtLink
                :to="$utm.utmUrl(APP_STORE_URL)"
                rel="noopener noreferrer"
              >
                <NuxtImg
                  alt="apple-store"
                  src="/images/home-v4/appstore2.webp"
                  width="177px"
                  height="52px"
                  class="max-w-full lg:h-13 rounded-xl border border-transparent dark:border-outline-variant"
                />
              </NuxtLink>
            </Motion>
            <div class="w-px h-1/2 bg-outline"></div>
            <CtaQr />
          </div>
          <p class="text-lg">
            Atau versi
            <NuxtLink
              :to="$utm.utmUrl(WEB_APP_URL)"
              rel="noopener noreferrer"
              class="font-bold underline"
            >
              Web Dashboard
            </NuxtLink>
          </p>
        </slot>
      </div>
      <slot name="hero">
        <div class="absolute right-8 bottom-0 xl:block hidden">
          <NuxtImg
            alt="Aplikasi Kirim Paket"
            :width="573"
            :height="407"
            src="/images/cta-light.webp"
          />
        </div>
      </slot>
    </UiContainer>
  </section>
</template>
